import React, { useEffect, useState } from 'react'
import { RiListRadio, RiDeleteBin2Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import toast from 'react-hot-toast';

import { addData, deleteData, editData, getData } from "../../controllers/jobListings.controller"

const JobListings = () => {

  const [image, setImage] = useState(null);
  const [data, setData] = useState([]);
  const [selectedRowId, setSelectedRowId] = useState(null);


  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted: ", formData);

  };

  const [formData, setFormData] = useState({
    job_title: "",
    platform_name: "",
    url: "",

  });

  const [editFormData, setEditFormData] = useState({
    job_title: "",
    platform_name: "",
    url: "",
  });

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData({ ...editFormData, [name]: value });
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };



  const fetchData = async () => {
    try {
      const res = await getData({});
      console.log("res => ", res);

      if (res.status === 200) {
        const apiData = res?.data?.data;
        const tableData = apiData?.map((d) => ({
          id: d.id,
          job_title: d.job_title,
          platform_name: d.platform_name,
          url: d.url

        }));
        setData(tableData);
      } else {
        toast.error("Failed to fetch data.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Something went wrong while fetching data.");
    }
  };
  useEffect(() => {
    fetchData();
  }, []);



  //edit
  const editBtn = async () => {
    try {
      const { job_title, platform_name, url } = editFormData;
console.log("editt", formData)
      if (!job_title || !platform_name || !url) {
        toast.error("Please fill in all the required fields and upload a document.");

        return;
      }

      toast.loading("Submitting your data...");


      const res = await editData({
        id: selectedRowId,
        job_title,
        platform_name,
        url
      });

      const message = res.data.message;
      toast.dismiss();

      if (res.status === 200) {
        toast.success(message);
        setFormData({
          job_title: "",
          platform_name: "",
          url: "",

        });

        document.getElementById("modal-edit").close()
        fetchData()
      } else {
        toast.error(message || "Failed to add research data.");
      }
    } catch (error) {
      toast.dismiss();
      console.error("Error adding research data:", error);


      const message = error?.response?.data?.message || "Something went wrong!";
      toast.error(message);
    }
  };


  const deleteBtn = async () => {
    try {
      if (selectedRowId) {
        toast.loading("Please wait...");
        const res = await deleteData({ id: selectedRowId })
        const message = res.data.message;
        toast.dismiss();
        if (res.status === 200) {
          toast.success(message);
          fetchData()
          setSelectedRowId(null)
          document.getElementById("modal-delete").close()
        } else {
          toast.error(message);
        }
      }
    } catch (error) {
      console.error(error);
      const message = error?.response?.data?.error || "Something went wrong!";
      toast.dismiss();
      toast.error(message);
    }
  }


  console.log('formdata => ', formData)

  const addBtn = async () => {
    try {
      const { job_title, platform_name, url } = formData;

      if (!job_title || !platform_name || !url) {
        toast.error("Please fill in all the required fields and upload a document.");
        return;
      }

      toast.loading("Submitting your data...");


      const res = await addData({
        job_title,
        platform_name,
        url

      });

      const message = res.data.message;
      toast.dismiss();

      if (res.status === 200) {
        toast.success(message);
        setFormData({

          job_title: "",
          platform_name: "",
          url: "",

        });

        fetchData()
      } else {
        toast.error(message || "Failed to add research data.");
      }
    } catch (error) {
      toast.dismiss();
      console.error("Error adding research data:", error);


      const message = error?.response?.data?.message || "Something went wrong!";
      toast.error(message);
    }
  };

  return (
    <div>
      <div>
        <div className="p-6">

          <div className='flex text-xl gap-10 items-center'>

          </div>

          <div className="container">
            <div className="p-6  mx-auto bg-white rounded-lg shadow-md">


              <form onSubmit={handleSubmit}>
                <div className="p-6">
                  <h1 className="text-2xl font-bold mb-6">Careers </h1>
                  <form onSubmit={(e) => e.preventDefault()}>
                    <div className="mb-4">
                      <label htmlFor="title" className="block text-sm font-medium text-gray-700">
                        Job Title
                      </label>
                      <input
                        id="job_title"
                        name="job_title"
                        value={formData.job_title}
                        onChange={handleChange}
                        className="block w-full border border-gray-300 rounded-lg px-3 py-2 shadow-sm"
                      />
                    </div>
                    <div className="mb-4">
                      <label htmlFor="url" className="block text-sm font-medium text-gray-700">
                        Platform Name
                      </label>
                      <input
                        id="platform_name"
                        name="platform_name"
                        value={formData.platform_name}
                        onChange={handleChange}
                        rows="4"
                        className="block w-full border border-gray-300 rounded-lg px-3 py-2 shadow-sm"
                      />
                    </div>

                    <div className="mb-4">
                      <label htmlFor="url" className="block text-sm font-medium text-gray-700">
                        Application Link
                      </label>
                      <input
                        id="url"
                        name="url"
                        value={formData.url}
                        onChange={handleChange}
                        rows="4"
                        className="block w-full border border-gray-300 rounded-lg px-3 py-2 shadow-sm"
                      />
                    </div>

                    <div className="flex justify-end space-x-4">
                     
                      <button
                        type="button"
                        onClick={addBtn}
                        className="px-4 py-2 bg-[#92288C] text-white rounded-md"
                      >
                        Add
                      </button>
                    </div>
                  </form>
                </div>
              </form>
            </div>

            <div className="p-6 mx-auto bg-white rounded-lg shadow-md mt-10">


              <table className="w-full border-collapse bg-white rounded-lg shadow-md">
                <thead>
                  <tr className="bg-gray-100 text-[#4B465C]">
                    <th className="py-2 px-4 w-1/4 text-center">Title</th>


                    <th className="py-2 px-4 w-1/4 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => (
                    <tr key={item.id} className="border-b hover:bg-gray-50">




                      <td className="py-2 px-4 text-center">{item.job_title}</td>


                      <td className="py-2 px-4 text-center">
                        <div className="flex justify-center gap-4">
                          <button
                            onClick={() => {
                              setSelectedRowId(item.id)
                              document.getElementById("modal-delete").showModal();
                            }}
                            className="flex items-center px-3 py-1 bg-[#A8AAAE14] text-[#A8AAAE] border border-[#A8AAAE] rounded-md hover:bg-gray-300"
                          >
                            Delete
                            <RiDeleteBin2Line className="ml-2" />
                          </button>

                          <button
                            onClick={() => {
                              setSelectedRowId(item.id)
                              setEditFormData({
                                job_title: item.job_title,
                                platform_name: item.platform_name,
                                url: item.url,
                              });

                              document.getElementById("modal-edit").showModal();
                            }}
                            className="px-3 py-1 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md flex items-center gap-1">
                            Edit
                            <FiEdit />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>


            <dialog
              id="modal-delete"
              className="modal modal-bottom sm:modal-middle inset-0 z-50 rounded-lg"
            >

              <div className="relative bg-white rounded-lg shadow-lg p-6 max-w-lg w-full mx-auto z-10">
                <div className="text-center">
                  <h2 className="text-xl font-bold text-gray-900">
                    Delete
                  </h2>
                  <p className="text-gray-500 font-bold">
                    Are you sure?
                  </p>
                </div>


                <div className="mt-4 flex justify-center space-x-4">
                  <button
                    onClick={() => {
                      setSelectedRowId(null)
                      document.getElementById("modal-delete").close()
                    }}
                    className="rounded-lg hover:bg-gray-200 transition active:scale-95 hover:shadow-lg px-6 py-3 bg-gray-200 text-gray-600"
                  >
                    No
                  </button>
                  <button
                    onClick={async () => { deleteBtn(); }}
                    className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                  >
                    Yes
                  </button>
                </div>
              </div>
            </dialog>


            <dialog
              id="modal-edit"
              className="modal modal-bottom xl:modal-middle inset-0 z-50 rounded-lg w-[500px]"
            >
              <div className="p-6  mx-auto bg-white rounded-lg shadow-md">


                <form onSubmit={handleSubmit}>
                  <div className="p-6">
                    <h1 className="text-2xl font-bold mb-6">Edit job list </h1>
                    <form onSubmit={(e) => e.preventDefault()}>




                      <div className="mb-4">
                        <label htmlFor="title" className="block text-sm font-medium text-gray-700">
                          Job Title
                        </label>
                        <input
                          id="job_title"
                          name="job_title"
                          value={editFormData.job_title}
                          onChange={handleEditChange}
                          className="block w-full border border-gray-300 rounded-lg px-3 py-2 shadow-sm"
                        />
                      </div>

                      <div className="mb-4">
                        <label htmlFor="url" className="block text-sm font-medium text-gray-700">
                          Platform Name
                        </label>
                        <input
                          id="platform_name"
                          name="platform_name"
                          value={editFormData.platform_name}
                          onChange={handleEditChange}
                          rows="4"
                          className="block w-full border border-gray-300 rounded-lg px-3 py-2 shadow-sm"
                        />
                      </div>

                      <div className="mb-4">
                        <label htmlFor="url" className="block text-sm font-medium text-gray-700">
                          Application Link
                        </label>
                        <input
                          id="url"
                          name="url"
                          value={editFormData.url}
                          onChange={handleEditChange}
                          rows="4"
                          className="block w-full border border-gray-300 rounded-lg px-3 py-2 shadow-sm"
                        />
                      </div>

                      <div className="flex justify-end space-x-4">
                        <button
                          type="button"
                          className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md"
                          onClick={() => {
                            document.getElementById("modal-edit").close()
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          onClick={editBtn}
                          className="px-4 py-2 bg-[#92288C] text-white rounded-md"
                        >
                          Update
                        </button>
                      </div>
                    </form>
                  </div>
                </form>
              </div>
            </dialog>



          </div>
        </div>
      </div>
    </div>
  )
}

export default JobListings

